import React, { useCallback, useEffect } from "react";
import Button from "../../elements/button";
import Card from "../../elements/card";
import Heading, { SmallText, Subheading } from "../../elements/text";
import Input from "../../elements/inputs";
import MainLink from "../../elements/link";
import { Formik, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
// import { useRouter } from "next/router";
import Cookies from "universal-cookie";
import { signupValidationSchema } from "../../../utils";

import {
  signup,
  signupSuccess,
  signupFail,
  signupPending,
} from "../../../store/auth/signupSlice";
import { toast } from "react-toastify";
import { createUser } from "../../../api-client/signup";
import { useRouter } from "next/router";
import { useState } from "react";
import { eyeOff, eye as eyeIcon } from "../../../public/assets/icons";
import Image from "next/image";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { signIn } from "next-auth/react";




const SignUpWidget = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { isLoading, isRegistered, error } = useSelector(signup);
  const [eye, setEye] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onFormSubmit = async (data) => {
    dispatch(signupPending());
    try {
      const res = await createUser(data);
      dispatch(signupSuccess(res.data));
      toast.info("Please Check your Email for Verification Code");

      // router.push("/auth/sign-in");
      router.push("/auth/email-verify");
    } catch (error) {
      toast.error(error.response?.data.message);
      dispatch(signupFail(error.response?.data.message));
    }
  };

  const submitFormRecaptcha = useCallback(
    async (data) => {
      // e.preventDefault();
      if (!executeRecaptcha) {
        console.log("Execute recaptcha not yet available");
        return;
      }
      executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
        const newData = {
          ...data,
          gReCaptchaToken: gReCaptchaToken,
        };

        onFormSubmit(newData);
      });
    },
    [executeRecaptcha]
  );
  return (
    <section className="flex justify-center items-center">
      <div className="mx-auto my-2">
        <Card>
          <header className="mb-6">
            <Heading>
              <p className="mb-3 text-left font-[600] text-[#061938] lg:text-[40px] text-[30px] leading-[43px]">
                Create Account
              </p>
            </Heading>
            <Subheading>
              <p className="text-left py-2 my-0 text-[16px] lg:text-[20px]">
                Already have an account?
                <MainLink href="/auth/sign-in" text=" Sign In" />
              </p>
            </Subheading>
          </header>

          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              email: "",
              password: "",
            }}
            validationSchema={signupValidationSchema}
            onSubmit={(data) => submitFormRecaptcha(data)}
          >
            {({ values, handleChange, handleSubmit, errors, touched }) => (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <div className="grid grid-cols-5 gap-2 mt-5">
                  <div className="col-span-3">
                    <p className="text-[#061938] leading-[20px] text-[14px] lg:text-[20px] lg:my-3 my-1">First name</p>
                    <Input
                      type="text"
                      placeholder="FirstName"
                      name="firstName"
                      error={errors.firstName && touched.firstName}
                      value={values.firstName}
                      onChange={handleChange}
                      className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                      errorMessage={
                        <ErrorMessage name="firstName">
                          {(msg) => (
                            <SmallText>
                              <p className="error-text"> {msg}</p>
                            </SmallText>
                          )}
                        </ErrorMessage>
                      }
                    />
                  </div>
                  <div className="col-span-2">
                    <p className="text-[#061938] leading-[20px] text-[14px] lg:text-[20px] lg:my-3 my-1">Last name</p>
                    <Input
                      type="text"
                      placeholder="LastName"
                      name="lastName"
                      error={errors.lastName && touched.lastName}
                      value={values.lastName}
                      onChange={handleChange}
                      className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                    />
                  </div>
                  <ErrorMessage name="lastName">
                    {(msg) => (
                      <SmallText>
                        <p className="error-text"> {msg}</p>
                      </SmallText>
                    )}
                  </ErrorMessage>
                </div>
                <div>
                  <p className="text-[#061938] leading-[20px] text-[14px] lg:text-[20px] lg:my-3 my-1">Email Address</p>
                  <Input
                    type="email"
                    placeholder="Email"
                    onChange={handleChange}
                    error={errors.email && touched.email}
                    value={values.email}
                    name="email"
                    className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                  />
                  <ErrorMessage name="email">
                    {(msg) => (
                      <SmallText>
                        <p className="error-text"> {msg}</p>
                      </SmallText>
                    )}
                  </ErrorMessage>
                </div>
                <p className="text-[#061938] leading-[20px] text-[14px] lg:text-[20px] lg:my-3 my-1">Password</p>
                <Input
                  type={eye ? "text" : "password"}
                  icon={<Image src={eye ? eyeIcon : eyeOff} alt="eyeIcon" />}
                  onPasswordToggle={() => setEye(!eye)}
                  placeholder="Password"
                  name="password"
                  error={errors.password && touched.password}
                  value={values.password}
                  onChange={handleChange}
                  className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                />
                <ErrorMessage name="password">
                  {(msg) => (
                    <SmallText>
                      <p className="error-text">{msg}</p>
                    </SmallText>
                  )}
                </ErrorMessage>
                <SmallText className="mt-3">
                  <p className="text-left lg:text-[20px] text-[14px] lg:leading-[24px] leading-[20px] font-[400] my-3">
                    By signing up, I agree to the{" "}
                    <a
                      className="text-[#505F79] font-bold hover:underline"
                      href="https://www.stakecut.com/terms-and-conditions"
                    >
                      Terms of Service
                    </a>{" "}
                    and{" "}
                    <a
                      className="text-[#505F79] font-bold hover:underline"
                      href="https://www.stakecut.com/privacy-policy"
                    >
                      Privacy Statement
                    </a>
                  </p>
                </SmallText>
                <Button
                  className="btn-primary mt-10 py-9 text-[14px] lg:text-[20px] px-4 w-full"
                  label="Create my free Account"
                  type="submit"
                  loading={isLoading}
                />
              </form>
            )}
          </Formik>
        </Card>
      </div>
    </section>
  );
};

export default SignUpWidget;















// const SignUpWidget = () => {
//   const dispatch = useDispatch();
//   const router = useRouter();
//   const { isLoading, isRegistered, error } = useSelector(signup);
//   const [eye, setEye] = useState(false);

//   const { executeRecaptcha } = useGoogleReCaptcha();

//   const onFormSubmit = async (data) => {
//     dispatch(signupPending());
//     try {
//       const res = await createUser(data);
//       dispatch(signupSuccess(res.data));
//       toast.info("Please Check your Email for Verification Code");

//       router.push("/auth/email-verify");
//     } catch (error) {
//       toast.error(error.response?.data.message);
//       dispatch(signupFail(error.response?.data.message));
//     }
//   };

//   const submitFormRecaptcha = useCallback(
//     async (data) => {
//       // e.preventDefault();
//       if (!executeRecaptcha) {
//         console.log("Execute recaptcha not yet available");
//         return;
//       }
//       executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
//         const newData = {
//           ...data,
//           gReCaptchaToken: gReCaptchaToken,
//         };

//         onFormSubmit(newData);
//       });
//     },
//     [executeRecaptcha]
//   );

//   return (
//     <section className="flex justify-center items-center ">
//       <div className=" mx-auto my-2 ">
//         <Card>
//           <header className="mb-6">
//             <Heading>
//               <p className="mb-3 text-left  font-[600] text-[#061938] lg:text-[40px] text-[30px] leading-[43px]">

//               Create Account
//               </p>
//               </Heading>
//             <Subheading>
//             <p className='text-left py-2 my-0 text-[16px] lg:text-[20px]'>

//               Already have an account?
//               <MainLink href="/auth/sign-in" text=" Sign In" />
//               </p>
//             </Subheading>
//           </header>

//           <Formik
//             // Initialise Initial Form Values
//             initialValues={{
//               firstName: "",
//               lastName: "",
//               email: "",
//               password: "",
//             }}
//             // Function for Error message Display
//             validationSchema={signupValidationSchema}
//             // Submit Function
//             onSubmit={(data) => submitFormRecaptcha(data)}
//           >
//             {({ values, handleChange, handleSubmit, errors, touched }) => (
//               <form
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   handleSubmit();
//                 }}
//               >
//                 <div className="grid grid-cols-5 gap-2 mt-5">
//                   <div className="col-span-3">
//                     <p className='text-[#061938] leading-[20px] text-[14px] lg:text-[20px]  lg:my-3 my-1   '>First name</p>
//                     <Input
//                       type="text"
//                       placeholder="FirstName"
//                       name="firstName"
//                       error={errors.firstName && touched.firstName}
//                       value={values.firstName}
//                       onChange={handleChange}
//                       className="border-[1px] rounded-[8px] border-[#B3BAC5]"
//                       errorMessage={
//                         <ErrorMessage name="firstName">
//                           {(msg) => (
//                             <SmallText>
//                               <p className="error-text"> {msg}</p>
//                             </SmallText>
//                           )}
//                         </ErrorMessage>
//                       }
//                     />
//                   </div>
//                   <div className="col-span-2">
//                   <p className='text-[#061938] leading-[20px] text-[14px] lg:text-[20px]  lg:my-3 my-1  '>Last name</p>

//                     <Input
//                       type="text"
//                       placeholder="LastName"
//                       name="lastName"
//                       error={errors.lastName && touched.lastName}
//                       value={values.lastName}
//                       onChange={handleChange}
//                       className="border-[1px] rounded-[8px] border-[#B3BAC5]"
//                     />
//                   </div>

//                   <ErrorMessage name="lastName">
//                     {(msg) => (
//                       <SmallText>
//                         <p className="error-text"> {msg}</p>
//                       </SmallText>
//                     )}
//                   </ErrorMessage>
//                 </div>
//                 <div>
//                 <p className='text-[#061938] leading-[20px] text-[14px] lg:text-[20px]  lg:my-3 my-1  '>Email Address</p>

//                   <Input
//                     type="email"
//                     placeholder="Email"
//                     onChange={handleChange}
//                     error={errors.email && touched.email}
//                     value={values.email}
//                     name="email"
//                     className="border-[1px] rounded-[8px] border-[#B3BAC5]"
//                   />
//                   <ErrorMessage name="email">
//                     {(msg) => (
//                       <SmallText>
//                         <p className="error-text"> {msg}</p>
//                       </SmallText>
//                     )}
//                   </ErrorMessage>
//                 </div>
//                 <p className='text-[#061938] leading-[20px] text-[14px] lg:text-[20px]  lg:my-3 my-1  fd'>Password</p>

//                 <Input
//                   type={eye ? "text" : "password"}
//                   icon={<Image src={eye ? eyeIcon : eyeOff} alt="eyeIcon" />}
//                   onPasswordToggle={() => setEye(!eye)}
//                   placeholder="Password"
//                   name="password"
//                   error={errors.password && touched.password}
//                   value={values.password}
//                   onChange={handleChange}
//                   className="border-[1px] rounded-[8px] border-[#B3BAC5]"
//                 />
//                 <ErrorMessage name="password">
//                   {(msg) => (
//                     <SmallText>
//                       <p className="error-text">{msg}</p>
//                     </SmallText>
//                   )}
//                 </ErrorMessage>
//                 <SmallText className="mt-3">
//                   <p className="text-left lg:text-[20px] text-[14px] lg:leading-[24px] leading-[20px] font-[400] my-3">

//                   By signing up, I agree to the{" "}
//                   <a
//                     className="text-[#505F79] font-bold hover:underline"
//                     href="https://www.stakecut.com/terms-and-conditions"
//                   >
//                     Terms of Service
//                   </a>{" "}
//                   and{" "}
//                   <a
//                     className="text-[#505F79] font-bold hover:underline"
//                     href="https://www.stakecut.com/privacy-policy"
//                   >
//                     Privacy Statement
//                   </a>
//                   </p>
                 
//                 </SmallText>
//                 <Button
//                   className="btn-primary mt-10 py-9 text-[14px] lg:text-[20px] px-4 w-full"
//                   label="Create my free Account"
//                   type="submit"
//                   loading={isLoading}
//                 />
//               </form>
//             )}
//           </Formik>
//         {/* <div className="flex flex-row items-center justify-center border-2">
//           <button
//             className="flex items-center justify-center text-center"
//             onClick={() => signIn("google")}
//           >
//             <Image
//               src="/assets/images/google.svg"
//               width={35}
//               height={30}
//               className="w-auto"
//             />
//             <p>Google</p>
//           </button>
//         </div> */}
//         </Card>
//       </div>
//     </section>
//   );
// };

// export default SignUpWidget;
